require('../../../scss/components/notice-box.scss');
import rwxNoticeBox from 'roseworx/js/components/rwxNoticeBox';

// window.addEventListener('load', ()=>{
// 	rwxNoticeBox.setConfig({position: "bottom-right", delay:5});
// });

document.getElementById('setValueDemo').addEventListener('click', ()=>{
	const val = document.getElementById('setValueVal').value;
	rwxNoticeBox.setValue(val, true, ()=>{console.log("done")});
});
